import Image from 'global/Image';
import { SectionContent } from 'global/LandingPage';
import Link from 'next/link';
import { toolsFeatures } from './constants';
import PricingPlan from './PricingPlan';
import { HeaderWrapper, HeaderTitle, ButtonInvest } from './styled';
import ScrollSpy from './uikit/Scrollspy';

function ProTools() {
  return (
    <>
      <HeaderWrapper>
        <div className="title-wrapper">
          <HeaderTitle>
            Professional Tools
            <br />
            untuk Pemula
          </HeaderTitle>
          <Link href="/register" passHref>
            <ButtonInvest>Buka Rekening Anda</ButtonInvest>
          </Link>
        </div>
        <div className="illustration">
          <Image
            src="/images/pro1.svg"
            alt="pro tools illustration"
            style={{ width: '100%' }}
          />
        </div>
      </HeaderWrapper>
      <ScrollSpy>
        {toolsFeatures.map((feat) => (
          <li key={feat.title} data-spy={feat.url}>
            <a href={`#${feat.url}`}>{feat.title}</a>
          </li>
        ))}
      </ScrollSpy>
      {toolsFeatures.map((feature) => (
        <SectionContent
          key={feature.url}
          id={feature.url}
          title={feature.title}
          label={feature.description}
          url={`/info/pro-tools/${feature.url}`}
          icon={`/images/${feature.icon}`}
          features={feature.features}
        />
      ))}
      <PricingPlan />
    </>
  );
}

export default ProTools;
